module.exports = __webpack_public_path__ + "media/images/home/mini/2-cab309de86f46f99cf0523c4f6dccd8f.png";